function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Svg from './Svg';
import styled from 'styled-components';
const BaseComponent = _ref => {
  let {
    size,
    title,
    desc,
    titleId,
    descId,
    ...props
  } = _ref;
  let ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? ` ${descId}` : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !ariaLabelledBy,
    fill: "currentcolor"
  }, props), !!title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#experienceTicket_svg__clip0_10_458)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.733.162l.136.042 1.71.624-.12.808a1.39 1.39 0 002.483 1.038l.073-.108.427-.696 1.71.622c.208.075.388.191.534.337l.08-.048a1.501 1.501 0 011.673.158l.107.097 1.95 1.951-.304.638a1.867 1.867 0 002.346 2.55l.143-.061.638-.305 1.95 1.95a1.5 1.5 0 01.098 2.015l-.097.107-11.452 11.452a1.5 1.5 0 01-2.015.097l-.107-.097-1.95-1.95.305-.639a1.867 1.867 0 00-2.346-2.55l-.143.061-.638.305L3.3 16.937l-1.343-.49a1.478 1.478 0 01-.925-1.758l.042-.136 4.9-13.465A1.478 1.478 0 017.734.162zm7.4 3.581L3.68 15.195a.5.5 0 00-.058.638l.058.07 1.45 1.45a2.867 2.867 0 013.898 3.652l-.075.17 1.45 1.451a.5.5 0 00.638.058l.07-.058 9.481-9.482a.534.534 0 01-.756 0l-.595-.595a.535.535 0 01.756-.755l.595.595a.535.535 0 010 .756l1.97-1.971a.5.5 0 00.058-.638l-.057-.07-1.451-1.45a2.867 2.867 0 01-3.897-3.652l.075-.17-1.45-1.45a.5.5 0 00-.708 0zm-3.41 6.048a1.5 1.5 0 012.014-.097l.107.097 2.67 2.67a1.5 1.5 0 01.098 2.015l-.097.107-4.022 4.022a1.5 1.5 0 01-2.014.097l-.107-.098-2.67-2.67a1.5 1.5 0 01-.098-2.014l.097-.107 4.022-4.022zm5.492-.024a.534.534 0 01.755 0l.596.595a.534.534 0 11-.756.756l-.595-.595a.534.534 0 010-.756zm-4.785.731L8.409 14.52a.5.5 0 00-.058.638l.058.069 2.67 2.67a.5.5 0 00.638.058l.07-.058 4.02-4.021a.5.5 0 00.058-.638l-.057-.07-2.67-2.67a.5.5 0 00-.639-.057l-.069.057zm2.758-2.758a.534.534 0 01.756 0l.595.596a.534.534 0 11-.756.755l-.595-.595a.534.534 0 010-.756zm-2.027-2.026a.534.534 0 01.756 0l.595.595a.534.534 0 11-.755.756l-.596-.595a.535.535 0 010-.756zm-6.21-4.362l-.036.078-.979 2.685a.535.535 0 01.609-.18l.79.288a.534.534 0 11-.365 1.004l-.79-.287a.535.535 0 01-.352-.527L2.014 14.895c-.08.22.011.462.207.576l.078.036.235.086a1.489 1.489 0 01.332-.986l.107-.119 2.544-2.544 1.399-3.841a1.5 1.5 0 011.784-.94l.138.043 1.039.378 4.073-4.073-.065-.045-.074-.035-.943-.342A2.39 2.39 0 018.45 1.66l.02-.173-.943-.344a.478.478 0 00-.576.208zm.943 7.011l-.039.082-.665 1.826 1.906-1.906-.6-.22a.5.5 0 00-.602.218zm1.344-3.448l.79.288a.534.534 0 11-.365 1.005l-.79-.288a.534.534 0 11.365-1.005z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "experienceTicket_svg__clip0_10_458"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};
const SvgExperienceTicket = styled(BaseComponent).withConfig({
  displayName: "ExperienceTicket__SvgExperienceTicket",
  componentId: "sc-12s1cwr-0"
})(["outline:none;"]);
SvgExperienceTicket.isIcon = true;
SvgExperienceTicket.defaultProps = {
  size: 24,
  tabIndex: -1,
  focusable: false,
  'aria-hidden': true,
  role: 'img'
};
export default SvgExperienceTicket;